var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"captcha__block",class:{ visible: _vm.getCaptchaVisibility }},[_c('div',{staticClass:"captcha__wrapper"}),_vm._v(" "),_c('div',{ref:"yaCaptcha",staticClass:"captcha"})])
}
var staticRenderFns = []

export { render, staticRenderFns }